var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThickArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2977 5.5294C11.3068 5.2022 11.1864 4.8721 10.9367 4.62238L7.44583 1.13151C6.96384 0.649522 6.18239 0.649522 5.7004 1.13151C5.21841 1.6135 5.21841 2.39496 5.7004 2.87695L7.11839 4.29494L1.23421 4.29494C0.552574 4.29494 2.9795e-08 4.84751 0 5.52914C-2.9795e-08 6.21078 0.552572 6.76335 1.23421 6.76335H7.11836L5.70038 8.18133C5.21839 8.66332 5.21839 9.44478 5.70038 9.92676C6.18237 10.4088 6.96383 10.4088 7.44582 9.92676L10.9367 6.4359C11.1863 6.18631 11.3066 5.85642 11.2977 5.5294Z",
    fill: "#41CBFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickArrowRight);
export default __webpack_public_path__ + "static/media/ThickArrowRight.3d23b83218ec1284644b8c3e715e86c9.svg";
export { ForwardRef as ReactComponent };